import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { grey400 } from 'material-ui/styles/colors';
import { Dialog, FlatButton, IconMenu, MenuItem, IconButton } from 'material-ui';
import { Link } from 'react-router-dom';
import Error from '../../../components/common/Error/Error';
import Loading from '../../../components/common/Loading/Loading';
import CommentSetting from '../../../components/common/CommentSetting/CommentSetting';
import ReportSetting from '../../../components/common/ReportSetting/ReportSetting';
import PushSetting from '../../../components/common/PushSetting/PushSetting';
import UserSetting from '../../../components/common/UserSetting/UserSetting';
import style from '../../../styles/styles';
import styles from './SettingsPage.css';
import AdminService, { SUPER_ADMIN } from '../../../services/admin';
import {
    fetchApp,
    putApp,
    postPushGroup,
    deletePushGroup,
    postPushSound,
    deletePushSound,
    postAppConfiguration,
} from '../../../store/apps/actions';
import SmartTypeList from '../../../components/type/SmartTypeList/SmartTypeList';
import SmartReportSubjectList
    from '../../../components/report/SmartReportSubjectList/SmartReportSubjectList';
import ModuleService from '../../../services/module';
import CustomFieldService from '../../../services/customfield';
import CustomFieldList from '../../../components/customfield/CustomFieldList/CustomFieldList';
import PushElementList from '../../../components/push/PushElementList/PushElementList';
import {
    deleteCustomField,
    getCustomFields,
    resetCustomField,
} from '../../../store/customfields/actions';
import { getAccessTokens } from '../../../store/accessTokens/actions';
import { resetType } from '../../../store/types/actions';
import { dispatchInfo } from '../../../store/infos/actions';
import SmartMediaTypeList
    from '../../../components/media/MediaType/SmartMediaTypeList/SmartMediaTypeList';
import withTranslation from '../../../hoc/withTranslation';
import {
    ADD_CF_ACHIEVEMENT_PAGE,
    ADD_CF_NEWS_PAGE,
    ADD_CF_POINT_PAGE,
    ADD_CF_TRAIL_PAGE,
    ADD_PUSH_GROUP_PAGE,
    ADD_PUSH_SOUND_PAGE, APPLICATION_PAGE, EDIT_APPLICATION_PAGE,
} from '../../../constants/routes';
import FirebaseSetting from '../../../components/common/FirebaseSetting/FirebaseSetting';
import DynamicLinkSetting from '../../../components/common/DynamicLinkSetting/DynamicLinkSetting';
import QuizSetting from '../../../components/common/QuizSetting/QuizSetting';
import AccessTokenSetting from '../../../components/common/AccessTokenSetting/AccessTokenSetting';
import OpenExploreSetting from '../../../components/common/OpenExploreSetting/OpenExploreSetting';
import KeycloakSetting from '../../../components/common/KeycloakSetting/KeycloakSetting';
import GamificationSetting
    from '../../../components/common/GamificationSetting/GamificationSetting';

const iconButtonElement = (
    <IconButton
        touch={true}
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon color={grey400} />
    </IconButton>
);

export class SettingsPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        getAccessTokens: PropTypes.func,
        accessTokens: PropTypes.array,
    };

    static defaultProps = {
        loading: true,
        app: null,
    };

    state = {
        customFieldToRemove: null,
        openRemoveCustomField: false,
        pushGroupToRemove: null,
        openRemovePushGroup: false,
        pushSoundToRemove: null,
        openRemovePushSound: false,
    };

    componentWillMount() {
        this.props.resetCustomField();
        this.props.resetType();
        this.update(this.props);
        this.fetchApplication();
        if (this.props.app) {
            this.props.getCustomFields(this.props.app.id);
            this.props.getAccessTokens(this.props.app.id);
        }
    }

    componentWillUpdate(nextProps) {
        if (nextProps !== this.props) {
            this.update(nextProps);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
            this.fetchApplication(nextProps.match.params.appId);
        }
        if (this.props.cfSending && !nextProps.cfSending) {
            if (this.state.customFieldToRemove) { // custom field has been deleted
                this.handleCloseCustomField();
            }
        }
        if (this.props.app
            !== nextProps.app
            && this.props.accessTokens
            !== nextProps.accessTokens) {
            this.props.getAccessTokens(nextProps.app);
        }
        if (this.props.sending && !nextProps.sending) {
            if (nextProps.app) {
                this.props.dispatchInfo(nextProps.app.name + ' settings saved');
            }

            if (this.state.pushGroupToRemove) {
                this.handleClosePushGroup();
            }

            if (this.state.pushSoundToRemove) {
                this.handleClosePushSound();
            }
        }

        if (nextProps.app && this.props.app && this.props.app.id !== nextProps.app.id) {
            this.props.getCustomFields(nextProps.app.id);
        }
        if (nextProps.app && this.props.app && this.props.app.id !== nextProps.app.id) {
            this.props.getAccessTokens(nextProps.app.id);
        }
        if (
            nextProps.app && !nextProps.sending && !nextProps.pending
            && !nextProps.cfs && !nextProps.cfPending && !nextProps.cfSending
        ) {
            this.props.getCustomFields(nextProps.app.id);
        }
    }

    update(props) {
        if (props.app && this.props.app && this.props.app.id !== props.app.id) {
            this.props.getCustomFields(props.app.id);
            this.props.getAccessTokens(props.app.id);
        }
    }

    // Fetch

    fetchApplication(appId = null) {
        if (this.props.match) {
            let id = appId || this.props.match.params.appId;
            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    // Configuration

    editConfiguration = (name, value) => {
        let app = this.props.app;
        app.configurations[name] = value;
        this.props.putApp(app.id, app);
    };

    editSingleConfiguration = (name, value, isFile = false) => {
        let app = this.props.app;
        if (isFile) {
            const formData = new FormData();
            formData.append(name, value);
            this.props.postAppConfiguration(app.id, formData, true);
        } else {
            let data = {
                [name]: value,
            };
            this.props.postAppConfiguration(app.id, data);
        }
    };

    // Handlers

    handleAddTrailCustomField = () => {
        this.props.history.push(ADD_CF_TRAIL_PAGE.replace(':appId', this.props.app.id));
    };

    handleAddPointCustomField = () => {
        this.props.history.push(ADD_CF_POINT_PAGE.replace(':appId', this.props.app.id));
    };

    handleAddNewsCustomField = () => {
        this.props.history.push(ADD_CF_NEWS_PAGE.replace(':appId', this.props.app.id));
    };

    handleAddAchievementCustomField = () => {
        this.props.history.push(ADD_CF_ACHIEVEMENT_PAGE.replace(':appId', this.props.app.id));
    };

    handleAddPushGroup = () => {
        this.props.history.push(ADD_PUSH_GROUP_PAGE.replace(':appId', this.props.app.id));
    };

    handleAddPushSound = () => {
        this.props.history.push(ADD_PUSH_SOUND_PAGE.replace(':appId', this.props.app.id));
    };

    // Delete custom field

    handleDeleteCustomField = (cf) => {
        this.setState({
            openRemoveCustomField: true,
            customFieldToRemove: cf,
        });
    };

    handleCloseCustomField = () => {
        this.setState({
            openRemoveCustomField: false,
            customFieldToRemove: null,
        });
    };

    deleteCustomField = () => {
        this.props.deleteCustomField(this.props.app.id, this.state.customFieldToRemove.id);
    };

    // Delete push group

    handleDeletePushGroup = (pushGroup) => {
        this.setState({
            openRemovePushGroup: true,
            pushGroupToRemove: pushGroup,
        });
    };

    handleClosePushGroup = () => {
        this.setState({
            openRemovePushGroup: false,
            pushGroupToRemove: null,
        });
    };

    deletePushGroup = () => {
        this.props.deletePushGroup(this.props.app.id, this.state.pushGroupToRemove.name);
    };

    // Delete push sound

    handleDeletePushSound = (pushSound) => {
        this.setState({
            openRemovePushSound: true,
            pushSoundToRemove: pushSound,
        });
    };

    handleClosePushSound = () => {
        this.setState({
            openRemovePushSound: false,
            pushSoundToRemove: null,
        });
    };

    deletePushSound = () => {
        this.props.deletePushSound(this.props.app.id, this.state.pushSoundToRemove.name);
    };

    // Render

    renderMenu() {
        let menu;

        if (AdminService.isAuthorized(SUPER_ADMIN, this.props.user)) {
            menu = (
                <IconMenu
                    style={styles.buttons}
                    iconButtonElement={iconButtonElement}
                    anchorOrigin={{
                        horizontal: 'right',
                        vertical: 'top',
                    }}
                    targetOrigin={{
                        horizontal: 'right',
                        vertical: 'top',
                    }}
                >
                    <Link to={APPLICATION_PAGE.replace(':appId', this.props.app.id)}>
                        <MenuItem>
                            {this.props.t('settings_page.view_app')}
                        </MenuItem>
                    </Link>
                    <Link to={EDIT_APPLICATION_PAGE.replace(':appId', this.props.app.id)}>
                        <MenuItem>
                            {this.props.t('settings_page.edit_app')}
                        </MenuItem>
                    </Link>
                </IconMenu>
            );
        }

        return menu;
    };

    renderDeletePushGroupDialog(group) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.loading}
                onClick={this.handleClosePushGroup}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.loading}
                onClick={this.deletePushGroup}
            />,
        ];

        return (
            <Dialog
                actions={actions}
                modal={false}
                open={this.state.openRemovePushGroup}
                onRequestClose={this.handleClosePushGroup}
            >
                {this.props.loading && <Loading paper={false} />}
                {!this.props.loading &&
                    <span>
                        <div
                            dangerouslySetInnerHTML={{
                                __html:
                                    this.props.t(
                                        'settings_page.remove_group_confirmation',
                                        { name: group.name },
                                    ),
                            }}
                        />
                    </span>
                }
            </Dialog>
        );
    }

    renderDeletePushSoundDialog(sound) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.loading}
                onClick={this.handleClosePushSound}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.loading}
                onClick={this.deletePushSound}
            />,
        ];

        return (
            <Dialog
                actions={actions}
                modal={false}
                open={this.state.openRemovePushSound}
                onRequestClose={this.handleClosePushSound}
            >
                {this.props.loading && <Loading paper={false} />}
                {!this.props.loading &&
                    <span>
                        <div
                            dangerouslySetInnerHTML={{
                                __html:
                                    this.props.t(
                                        'settings_page.remove_sound_confirmation',
                                        { name: sound.name },
                                    ),
                            }}
                        />
                    </span>
                }
            </Dialog>
        );
    }

    renderDeleteCustomFieldDialog(cf) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.cfSending}
                onClick={this.deleteCustomField}
            />,
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.cfSending}
                onClick={this.handleCloseCustomField}
            />,
        ];

        return (
            <Dialog
                actions={actions}
                modal={this.props.cfSending}
                open={this.state.openRemoveCustomField}
                onRequestClose={this.handleCloseCustomField}
            >
                {this.props.cfSending && <Loading paper={false} />}
                {!this.props.cfSending &&
                    <span>
                        <div
                            dangerouslySetInnerHTML={{
                                __html:
                                    this.props.t(
                                        'settings_page.remove_custom_field_confirmation',
                                        { name: cf.name },
                                    ),
                            }}
                        />
                    </span>
                }
            </Dialog>
        );
    }

    render() {
        const isSuperAdmin = AdminService.isAuthorized(SUPER_ADMIN, this.props.user);

        if (this.props.appError) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app) {
            return <Loading paper={false} />;
        } else {
            return (
                <div
                    style={{
                        overflowX: 'hidden',
                        paddingRight: '3px',
                        paddingLeft: '3px',
                    }}
                >
                    {this.state.customFieldToRemove
                        && this.renderDeleteCustomFieldDialog(this.state.customFieldToRemove)}
                    {this.state.pushGroupToRemove
                        && this.renderDeletePushGroupDialog(this.state.pushGroupToRemove)}
                    {this.state.pushSoundToRemove
                        && this.renderDeletePushSoundDialog(this.state.pushSoundToRemove)}
                    {this.renderMenu()}
                    <h2 style={style.navigation}>
                        {this.props.t('generic.application')} / {this.props.t('generic.settings')}
                        {' - '}
                        {this.props.app.name}
                    </h2>
                    <div>
                        <h3 style={style.navigation}>Types</h3>
                        <div className="row">
                            <div
                                className="col-xs-12 col-sm-12 col-md-12 col-lg-6"
                                style={style.margin.bottom.small}
                            >
                                <SmartTypeList title={this.props.t('generic.types')} />
                            </div>
                            <div
                                className="col-xs-12 col-sm-12 col-md-12 col-lg-6"
                                style={style.margin.bottom.small}
                            >
                                <SmartMediaTypeList
                                    title={this.props.t('settings_page.media_types')}
                                />
                            </div>
                        </div>
                    </div>

                    {ModuleService.hasModule(this.props.app, ModuleService.USER) &&
                        <div>
                            <h3 style={style.navigation}>
                                {ModuleService.translatedNameForId(ModuleService.USER)}
                                {' - '}
                                {this.props.t('generic.settings')}
                            </h3>
                            <div className="row">
                                <div className="col-xs-12">
                                    <UserSetting
                                        app={this.props.app}
                                        loading={this.props.loading}
                                        editConfiguration={this.editSingleConfiguration}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {ModuleService.hasModule(this.props.app, ModuleService.KEYCLOAK) &&
                        <div>
                            <h3 style={style.navigation}>
                                {ModuleService.translatedNameForId(ModuleService.KEYCLOAK)}
                                {' - '}
                                {this.props.t('generic.settings')}
                            </h3>
                            <div className="row">
                                <div className="col-xs-12">
                                    <KeycloakSetting
                                        app={this.props.app}
                                        loading={this.props.loading}
                                        editConfiguration={this.editSingleConfiguration}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {ModuleService.hasModule(this.props.app, ModuleService.OPEN_EXPLORE) &&
                        <div>
                            <h3 style={style.navigation}>
                                {ModuleService.translatedNameForId(ModuleService.OPEN_EXPLORE)}
                                {' - '}
                                {this.props.t('generic.settings')}
                            </h3>
                            <div className="row">
                                <div
                                    className="col-xs-12"
                                    style={style.margin.bottom.small}
                                >
                                    <OpenExploreSetting
                                        app={this.props.app}
                                        loading={this.props.loading}
                                        editConfiguration={this.editSingleConfiguration}
                                    />
                                </div>
                            </div>
                            <h3 style={style.navigation}>
                                {ModuleService.translatedNameForId(ModuleService.OPEN_EXPLORE)}
                                {' - '}
                                {this.props.t('generic.custom_fields')}
                            </h3>
                            <div className="row">
                                <div
                                    className="col-xs-12 col-sm-12 col-md-6 col-lg-6"
                                    style={style.margin.bottom.small}
                                >
                                    <CustomFieldList
                                        handleRemoveCustomField={this.handleDeleteCustomField}
                                        app={this.props.app}
                                        user={this.props.user}
                                        title={this.props.t('module.open_explore.point_plural')}
                                        loading={this.props.cfPending}
                                        handleAddCustomField={isSuperAdmin
                                            ? this.handleAddPointCustomField
                                            : null}
                                        customFields={CustomFieldService.filter(
                                            this.props.cfs,
                                            CustomFieldService.OPEN_EXPLORE_POINT,
                                        )}
                                    />
                                </div>
                                <div
                                    className="col-xs-12 col-sm-12 col-md-6 col-lg-6"
                                    style={style.margin.bottom.small}
                                >
                                    <CustomFieldList
                                        handleRemoveCustomField={this.handleDeleteCustomField}
                                        app={this.props.app}
                                        user={this.props.user}
                                        title={this.props.t('module.open_explore.trail_plural')}
                                        loading={this.props.cfPending}
                                        handleAddCustomField={isSuperAdmin
                                            ? this.handleAddTrailCustomField
                                            : null}
                                        customFields={CustomFieldService.filter(
                                            this.props.cfs,
                                            CustomFieldService.OPEN_EXPLORE_TRAIL,
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {ModuleService.hasModule(this.props.app, ModuleService.NEWS) &&
                        <div>
                            <h3 style={style.navigation}>
                                {ModuleService.translatedNameForId(ModuleService.NEWS)}
                                {' - '}
                                {this.props.t('generic.custom_fields')}
                            </h3>
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <CustomFieldList
                                        handleRemoveCustomField={this.handleDeleteCustomField}
                                        app={this.props.app}
                                        user={this.props.user}
                                        title={this.props.t('module.news.plural')}
                                        loading={this.props.cfPending}
                                        handleAddCustomField={isSuperAdmin
                                            ? this.handleAddNewsCustomField
                                            : null}
                                        customFields={CustomFieldService.filter(
                                            this.props.cfs,
                                            CustomFieldService.NEWS,
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {ModuleService.hasModule(this.props.app, ModuleService.GAMIFICATION) &&
                        <div>
                            <h3 style={style.navigation}>
                                {ModuleService.translatedNameForId(ModuleService.GAMIFICATION)}
                                {' - '}
                                {this.props.t('generic.settings')}
                            </h3>
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <GamificationSetting
                                        app={this.props.app}
                                        loading={this.props.loading}
                                        editConfiguration={this.editSingleConfiguration}
                                    />
                                </div>
                            </div>
                            <h3 style={style.navigation}>
                                {ModuleService.translatedNameForId(ModuleService.GAMIFICATION)}
                                {' - '}
                                {this.props.t('generic.custom_fields')}
                            </h3>
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <CustomFieldList
                                        handleRemoveCustomField={this.handleDeleteCustomField}
                                        app={this.props.app}
                                        user={this.props.user}
                                        title={this.props.t('module.gamification.achievements')}
                                        loading={this.props.cfPending}
                                        handleAddCustomField={isSuperAdmin
                                            ? this.handleAddAchievementCustomField
                                            : null}
                                        customFields={CustomFieldService.filter(
                                            this.props.cfs,
                                            CustomFieldService.ACHIEVEMENT,
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {ModuleService.hasModule(this.props.app, ModuleService.QUIZ) &&
                        <div>
                            <h3 style={style.navigation}>
                                {ModuleService.translatedNameForId(ModuleService.QUIZ)}
                                {' - '}
                                {this.props.t('generic.settings')}
                            </h3>
                            <div className="row">
                                <div
                                    className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                    style={style.margin.bottom.small}
                                >
                                    <QuizSetting
                                        app={this.props.app}
                                        loading={this.props.loading}
                                        editConfiguration={this.editSingleConfiguration}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {ModuleService.hasModule(this.props.app, ModuleService.REPORT) &&
                        <div>
                            <h3 style={style.navigation}>
                                {ModuleService.translatedNameForId(ModuleService.REPORT)}
                                {' - '}
                                {this.props.t('generic.settings')}
                            </h3>
                            <div className="row">
                                <div
                                    className="col-xs-12 col-sm-12 col-md-12 col-lg-6"
                                    style={style.margin.bottom.small}
                                >
                                    <ReportSetting
                                        app={this.props.app}
                                        loading={this.props.loading}
                                        editConfiguration={this.editSingleConfiguration}
                                    />
                                </div>
                                <div
                                    className="col-xs-12 col-sm-12 col-md-12 col-lg-6"
                                    style={style.margin.bottom.small}
                                >
                                    <SmartReportSubjectList
                                        title={this.props.t('module.report.subject_name')}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {ModuleService.hasModule(this.props.app, ModuleService.COMMENTS) &&
                        <div>
                            <h3 style={style.navigation}>
                                {ModuleService.translatedNameForId(ModuleService.COMMENTS)}
                                {' - '}
                                {this.props.t('generic.settings')}
                            </h3>
                            <div className="row">
                                <div
                                    className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                    style={style.margin.bottom.small}
                                >
                                    <CommentSetting
                                        app={this.props.app}
                                        loading={this.props.loading}
                                        editConfiguration={this.editSingleConfiguration}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {ModuleService.hasModule(this.props.app, ModuleService.PUSH) && isSuperAdmin &&
                        <div>
                            <h3 style={style.navigation}>
                                {ModuleService.translatedNameForId(ModuleService.PUSH)}
                                {' - '}
                                {this.props.t('generic.settings')}
                            </h3>
                            <div className="row">
                                <div
                                    className="col-xs-12 col-sm-12 col-md-6 col-lg-4"
                                    style={style.margin.bottom.small}
                                >
                                    <PushSetting
                                        app={this.props.app}
                                        loading={this.props.loading}
                                        editConfiguration={this.editSingleConfiguration}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                                    <PushElementList
                                        handleRemovePushElement={this.handleDeletePushGroup}
                                        app={this.props.app}
                                        user={this.props.user}
                                        title="Groups"
                                        loading={this.props.loading}
                                        handleAddPushElement={isSuperAdmin
                                            ? this.handleAddPushGroup
                                            : null}
                                        elements={this.props.app.push_groups}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                                    <PushElementList
                                        handleRemovePushElement={this.handleDeletePushSound}
                                        app={this.props.app}
                                        user={this.props.user}
                                        title="Sounds"
                                        loading={this.props.loading}
                                        handleAddPushElement={isSuperAdmin
                                            ? this.handleAddPushSound
                                            : null}
                                        elements={this.props.app.push_sounds}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {ModuleService.hasModule(this.props.app, ModuleService.FIREBASE)
                        && isSuperAdmin
                        &&
                        <div>
                            <h3 style={style.navigation}>
                                {ModuleService.translatedNameForId(ModuleService.FIREBASE)}
                                {' - '}
                                {this.props.t('generic.settings')}
                            </h3>
                            <div className="row">
                                <div
                                    className="col-xs-12 col-sm-12 col-md-6 col-lg-4"
                                    style={style.margin.bottom.small}
                                >
                                    <FirebaseSetting
                                        app={this.props.app}
                                        loading={this.props.loading}
                                        editConfiguration={this.editSingleConfiguration}
                                    />
                                </div>
                                {ModuleService.hasModule(this.props.app, ModuleService.DYNAMIC_LINK)
                                    && isSuperAdmin
                                    &&
                                    <div
                                        className="col-xs-12 col-sm-12 col-md-6 col-lg-4"
                                        style={style.margin.bottom.small}
                                    >
                                        <DynamicLinkSetting
                                            app={this.props.app}
                                            loading={this.props.loading}
                                            editConfiguration={this.editSingleConfiguration}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    }
                    {ModuleService.hasModule(this.props.app, ModuleService.ACCESS_TOKEN) && (
                        <div>
                            <h3 style={style.navigation}>
                                {ModuleService.translatedNameForId(ModuleService.ACCESS_TOKEN)}
                                {' - '}
                                {this.props.t('generic.settings')}
                            </h3>
                            <div className="row">
                                <div
                                    className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                    style={style.margin.bottom.small}
                                >
                                    <AccessTokenSetting
                                        app={this.props.app}
                                        loading={this.props.accessTokensPending}
                                        accessTokens={this.props.accessTokens}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        user: state.auth.content,
        loading: state.apps.pending,
        pending: state.apps.pending,
        sending: state.apps.sending,
        appError: state.apps.error,
        cfs: state.customFields.content,
        cfPending: state.customFields.pending,
        cfSending: state.customFields.sending,
        app: state.apps.currentApplication,
        accessTokens: state.accessTokens.content,
        accessTokensPending: state.accessTokens.pending,
        accessSending: state.accessTokens.sending,
    };
}

export default connect(mapStateToProps, {
    resetType,
    resetCustomField,
    deleteCustomField,
    getCustomFields,
    fetchApp,
    putApp,
    postAppConfiguration,
    postPushGroup,
    deletePushGroup,
    postPushSound,
    deletePushSound,
    dispatchInfo,
    getAccessTokens,
})(withTranslation(SettingsPage));



// WEBPACK FOOTER //
// src/containers/common/SettingsPage/SettingsPage.js